module.exports = __webpack_public_path__ + "static/media/SpiritRelease.a8a6a57d.mp3";